import * as cookieStorage from '../services/cookie-storage-service';
import * as localStorage from '../services/local-storage-service';
import { getDomainName } from '../utils/url';
import { isElectron, isMobile } from 'services/env-service';

const STORAGE_KEY = 'auth';

const getStorage = () => isElectron() ? localStorage : cookieStorage;

const getCookieConfig = () => {
    if (isElectron() || isMobile) {
        return null;
    }

    const options = {
        domain: getDomainName(window.location.hostname),
        expires: 365
    };

    if (window.inWebex) {
        options.sameSite = 'None';
        options.secure = true;
    }

    return options;
}

export const fetchAuthDetails = () => {
    return getStorage().get(STORAGE_KEY);
}

export const setAuthDetails = (masterToken, teamToken, teamUrl) => {
    const details = getStorage().get(STORAGE_KEY) || {};
    getStorage().set(STORAGE_KEY, Object.assign({}, details, { masterToken, teamToken, teamUrl }), getCookieConfig());
}

export const setMasterToken = masterToken => {
    const details = getStorage().get(STORAGE_KEY) || {};
    getStorage().set(STORAGE_KEY, Object.assign({}, details, { masterToken }), getCookieConfig());
}

export const setTeamUrl = teamUrl => {
    const details = getStorage().get(STORAGE_KEY) || {};
    getStorage().set(STORAGE_KEY, Object.assign({}, details, { teamUrl }), getCookieConfig());
}

export const setTeamToken = (teamUrl, teamToken) => {
    const details = getStorage().get(STORAGE_KEY) || {};
    getStorage().set(STORAGE_KEY, Object.assign({}, details, { teamToken, teamUrl }), getCookieConfig());
}

export const removeTeamToken = teamUrl => {
    const details = getStorage().get(STORAGE_KEY) || {};
    getStorage().set(STORAGE_KEY, Object.assign({}, details, { teamToken: null, teamUrl: null }), getCookieConfig());
}
